(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('ProductPriceDialogController', ProductPriceDialogController);

    ProductPriceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductPrice', 'Product'];

    function ProductPriceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductPrice, Product) {
        var vm = this;
        vm.productPrice = entity;
        vm.products = Product.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:productPriceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.productPrice.id !== null) {
                ProductPrice.update(vm.productPrice, onSaveSuccess, onSaveError);
            } else {
                ProductPrice.save(vm.productPrice, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startedDate = false;
        vm.datePickerOpenStatus.endedDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };
    }
})();
